
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiClassiGrid extends Serenity.EntityGrid<ProdottiClassiRow, any> {
        protected getColumnsKey() { return ProdottiClassiColumns.columnsKey; }
        protected getDialogType() { return ProdottiClassiDialog; }
        protected getIdProperty() { return ProdottiClassiRow.idProperty; }
        protected getInsertPermission() { return ProdottiClassiRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiClassiRow.localTextPrefix; }
        protected getService() { return ProdottiClassiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}